import { render, staticRenderFns } from "./choosePoint.vue?vue&type=template&id=b44c1c88&scoped=true&"
import script from "./choosePoint.vue?vue&type=script&lang=js&"
export * from "./choosePoint.vue?vue&type=script&lang=js&"
import style0 from "./choosePoint.vue?vue&type=style&index=0&id=b44c1c88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44c1c88",
  null
  
)

export default component.exports